import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";
import TransitionsModal from "../../components/Modal";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import {
  deleteApi,
  getApi,
  postApi,
  putFormDataApi,
} from "../../config/configAxios";
import Swal from "sweetalert2";
import CustomLoader from "../../components/CustomLoader";
import { config } from "../../utils/JoditConfig";
import JoditEditor from "jodit-react";
import AdminLayout from "../../layouts/adminLayout/AdminLayout";

const AboutUsContent = () => {
  const [data, setData] = useState([]);
  const [storeData, setStoreData] = useState({});
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);
  const [openStore, setOpenStore] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [category, setCategory] = useState([]);

  const fetchData = async () => {
    try {
      const res = await getApi(`about-us-content`);
      setData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategory = async () => {
    try {
      const res = await getApi(`about-us-category`);
      setCategory(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchCategory();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStoreData((prevData) => ({ ...prevData, [name]: value }));
  };

  /// store
  const handleStore = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("date_en", storeData.date_en);
    formData.append("date_bn", storeData.date_bn);
    formData.append("year_en", storeData.year_en);
    formData.append("year_bn", storeData.year_bn);
    formData.append("title_en", storeData.title_en);
    formData.append("title_bn", storeData.title_bn);
    formData.append("content_en", storeData.content_en);
    formData.append("content_bn", storeData.content_bn);
    formData.append("card_color", storeData.card_color);
    formData.append("bnt_color", storeData.bnt_color);
    formData.append("about_us_category_id", storeData.about_us_category_id);
    try {
      await postApi(`about-us-content`, formData);
      setOpenStore(false);
      setStoreData({});
      fetchData();
      toast.success("Data created successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "update failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  // delete
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Confirm delete",
      text: "Are you sure you want to delete this?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          try {
            await deleteApi(`about-us-content/${id}`)
              .then((res) => {
                toast.success("Data deleted successfully!");
              })
              .catch((err) => {
                toast.error("An error occurred while updating status");
              })
              .finally(() => {
                fetchData();
              });
          } catch (err) {
            toast.error(err?.response?.data?.error || "update failed");
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while delete the user.",
            "error"
          );
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The user was not deleted.", "info");
      }
    });
  };

  // edit
  const handleEdit = async (id) => {
    setOpenEdit(true);
    try {
      const res = await getApi(`about-us-content/${id}`);
      setEditData(res.data.data);
      setStoreData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    }
  };
  // handleUpdate
  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("id", editData.id);
    formData.append("_method", "PUT");
    formData.append("date_en", storeData.date_en);
    formData.append("date_bn", storeData.date_bn);
    formData.append("year_en", storeData.year_en);
    formData.append("year_bn", storeData.year_bn);
    formData.append("title_en", storeData.title_en);
    formData.append("title_bn", storeData.title_bn);
    formData.append("content_en", storeData.content_en);
    formData.append("content_bn", storeData.content_bn);
    formData.append("card_color", storeData.card_color);
    formData.append("bnt_color", storeData.bnt_color);
    formData.append("about_us_category_id", storeData.about_us_category_id);
    try {
      await putFormDataApi(`about-us-content`, formData);
      setOpenEdit(false);
      setStoreData({});
      fetchData();
      toast.success("Data updated successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "update failed");
    } finally {
      setIsSubmitting(false);
    }
  };
  console.log(storeData);
  return (
    <AdminLayout title={"About us content"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <div>
          <div className="flex justify-between p-3">
            <h1 className="text-gray-700 font-medium">About us content list</h1>
            <div>
              <button className="btn-indigo" onClick={() => setOpenStore(true)}>
                Add new
              </button>
            </div>
          </div>
          <div className="table-wrap">
            <table className="table-main shadow-md">
              <thead className="table-h">
                <tr>
                  <th className="table-h">SN</th>
                  <th className="table-h">Category</th>
                  <th className="table-h">Title EN</th>
                  <th className="table-h">Action</th>
                </tr>
              </thead>
              <tbody className="table-b">
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td className="table-b">{index + 1}</td>

                    <td className="table-b">
                      {item.about_us_category.title_en}
                    </td>
                    <td className="table-b">{item.title_en}</td>
                    <td className="table-b">
                      <Box display="flex">
                        <IconButton
                          className="mr-3"
                          onClick={() => handleDelete(item.id)}
                        >
                          <Delete className="text-red-500" />
                        </IconButton>
                        <IconButton
                          className="mr-3"
                          onClick={() => handleEdit(item.id)}
                        >
                          <Icon icon={"bxs:edit"} className="text-blue-500" />
                        </IconButton>
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* modal  */}

      <TransitionsModal title={"Add"} open={openStore} setOpen={setOpenStore}>
        <form className="" onSubmit={handleStore}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div className="md:col-span-2">
              <label
                htmlFor="about_us_category_id"
                className="font-semibold text-sm"
              >
                Select category
              </label>
              <select
                id="about_us_category_id"
                name="about_us_category_id"
                onChange={handleInputChange}
                className="form-control"
                required
              >
                <option className="p-2 rounded-md bottom-0" value="">
                  select
                </option>
                {category?.map((item) => (
                  <option
                    key={item.id}
                    className="p-2 rounded-md bottom-0"
                    value={item.id}
                  >
                    {item.title_en}
                  </option>
                ))}
              </select>
            </div>
            <div className="md:col-span-2">
              <label htmlFor="date_en" className="font-semibold text-sm">
                Date EN
              </label>
              <input
                type="text"
                id="date_en"
                name="date_en"
                onChange={handleInputChange}
                placeholder="date_en"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="date_bn" className="font-semibold text-sm">
                Date BN
              </label>
              <input
                type="text"
                id="date_bn"
                name="date_bn"
                onChange={handleInputChange}
                placeholder="date_bn"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="year_en" className="font-semibold text-sm">
                Year EN
              </label>
              <input
                type="text"
                id="year_en"
                name="year_en"
                onChange={handleInputChange}
                placeholder="year_en"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="year_bn" className="font-semibold text-sm">
                Year BN
              </label>
              <input
                type="text"
                id="year_bn"
                name="year_bn"
                onChange={handleInputChange}
                placeholder="year_bn"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>
              <input
                type="text"
                id="title_en"
                name="title_en"
                onChange={handleInputChange}
                placeholder="title_en"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>
              <input
                type="text"
                id="title_bn"
                name="title_bn"
                onChange={handleInputChange}
                placeholder="title_bn"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label
                htmlFor="card_color"
                className="font-semibold text-sm block"
              >
                Card color
              </label>
              <input
                type="color"
                id="card_color"
                name="card_color"
                onChange={handleInputChange}
                placeholder="card_color"
                className="form-control h-20 w-20"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label
                htmlFor="bnt_color"
                className="font-semibold text-sm block"
              >
                Button color
              </label>
              <input
                type="color"
                id="bnt_color"
                name="bnt_color"
                onChange={handleInputChange}
                placeholder="bnt_color"
                className="form-control h-20 w-20"
                required
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="content_en" className="font-semibold text-sm">
                Content EN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_en}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_en: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="content_bn" className="font-semibold text-sm">
                Content BN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_bn}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_bn: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
      <TransitionsModal title={"Edit"} open={openEdit} setOpen={setOpenEdit}>
        <form className="" onSubmit={handleUpdate}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div className="md:col-span-2">
              <label
                htmlFor="about_us_category_id"
                className="font-semibold text-sm"
              >
                Select category
              </label>
              <select
                id="about_us_category_id"
                name="about_us_category_id"
                onChange={handleInputChange}
                placeholder="select heading"
                className="form-control"
                required
              >
                <option className="p-2 rounded-md bottom-0" value="">
                  select
                </option>
                {category?.map((item) => (
                  <option
                    key={item.id}
                    className="p-2 rounded-md bottom-0"
                    value={item.id}
                    selected={storeData?.about_us_category_id === item.id}
                  >
                    {item.title_en}
                  </option>
                ))}
              </select>
            </div>

            <div className="md:col-span-2">
              <label htmlFor="date_en" className="font-semibold text-sm">
                Date EN
              </label>
              <input
                type="text"
                id="date_en"
                name="date_en"
                value={storeData?.date_en}
                onChange={handleInputChange}
                placeholder="Charger votre fichier"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="date_bn" className="font-semibold text-sm">
                Date BN
              </label>
              <input
                type="text"
                id="date_bn"
                name="date_bn"
                value={storeData?.date_bn}
                onChange={handleInputChange}
                placeholder="Charger votre fichier"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="year_en" className="font-semibold text-sm">
                Year EN
              </label>
              <input
                type="text"
                id="year_en"
                name="year_en"
                value={storeData?.year_en}
                onChange={handleInputChange}
                placeholder="Charger votre fichier"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="year_bn" className="font-semibold text-sm">
                Year BN
              </label>
              <input
                type="text"
                id="year_bn"
                name="year_bn"
                value={storeData?.year_bn}
                onChange={handleInputChange}
                placeholder="Charger votre fichier"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>
              <input
                type="text"
                id="title_en"
                name="title_en"
                value={storeData?.title_en}
                onChange={handleInputChange}
                placeholder="Charger votre fichier"
                className="form-control"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>
              <input
                type="text"
                id="title_bn"
                name="title_bn"
                value={storeData?.title_bn}
                onChange={handleInputChange}
                placeholder="Charger votre fichier"
                className="form-control"
                required
              />
            </div>

            <div className="md:col-span-2">
              <label
                htmlFor="card_color"
                className="font-semibold text-sm block"
              >
                Card color
              </label>
              <input
                type="color"
                id="card_color"
                name="card_color"
                value={storeData?.card_color}
                onChange={handleInputChange}
                placeholder="card_color"
                className="form-control h-20 w-20"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label
                htmlFor="bnt_color"
                className="font-semibold text-sm block"
              >
                Button color
              </label>
              <input
                type="color"
                id="bnt_color"
                name="bnt_color"
                value={storeData?.bnt_color}
                onChange={handleInputChange}
                placeholder="bnt_color"
                className="form-control h-20 w-20"
                required
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="content_en" className="font-semibold text-sm">
                Content EN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_en}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_en: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="content_bn" className="font-semibold text-sm">
                Content BN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_bn}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_bn: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Update"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
    </AdminLayout>
  );
};

export default AboutUsContent;
